<ng-container *transloco="let t">
    <section
        class="workbook-sheet-picker"
        [attr.aria-label]="t(isMultiFile ? 'Choose what to upload' : 'Choose sheets to upload')"
    >
        <div class="workbook-sheet-picker__intro">
            <h2 class="workbook-sheet-picker__title">
                {{ t(isMultiFile ? "Choose what to upload" : "Choose sheets to upload") }}
            </h2>
            <p class="workbook-sheet-picker__lead">
                <ng-container *ngIf="isMultiFile; else singleFileLead">
                    {{ t("You selected {{files}} files with {{sheets}} sheets in total. Each sheet you select becomes its own table.", { files: groups.length, sheets: sheetCount }) }}
                </ng-container>
                <ng-template #singleFileLead>
                    <span *ngIf="groups[0]?.fileName" class="workbook-sheet-picker__file">{{ groups[0].fileName }}</span>
                    {{ t("This workbook has {{count}} sheets. Each sheet you select becomes its own table.", { count: sheetCount }) }}
                </ng-template>
            </p>
        </div>

        <div class="workbook-sheet-picker__toolbar">
            <mat-checkbox
                [checked]="allSelected"
                [indeterminate]="someSelected"
                [disabled]="!selectableSheets.length"
                (change)="toggleAll($event.checked)"
            >
                {{ t("Select all sheets") }}
            </mat-checkbox>
            <span class="sai-badge">
                {{ t("{{selected}} of {{total}} selected", { selected: selected.size, total: selectableSheets.length }) }}
            </span>
        </div>

        <div
            *ngFor="let group of groups; trackBy: trackByGroup"
            class="workbook-sheet-picker__group"
            [class.workbook-sheet-picker__group--multi]="isMultiFile"
        >
            <div *ngIf="isMultiFile" class="workbook-sheet-picker__group-head">
                <mat-checkbox
                    *ngIf="selectableIn(group).length > 1; else fileTitle"
                    class="workbook-sheet-picker__checkbox"
                    [checked]="isGroupAllSelected(group)"
                    [indeterminate]="isGroupPartlySelected(group)"
                    (change)="toggleGroup(group, $event.checked)"
                >
                    <ng-container *ngTemplateOutlet="fileTitle"></ng-container>
                </mat-checkbox>
                <ng-template #fileTitle>
                    <span class="workbook-sheet-picker__file-title">
                        <mat-icon class="icon-size-5" svgIcon="heroicons_outline:document-text"></mat-icon>
                        <span class="workbook-sheet-picker__file-name">{{ group.fileName }}</span>
                    </span>
                </ng-template>
                <span class="sai-badge sai-badge--rect">
                    {{
                        group.kind === "csv"
                            ? t("CSV")
                            : group.sheets.length === 1
                              ? t("Excel")
                              : t("Excel, {{count}} sheets", { count: group.sheets.length })
                    }}
                </span>
            </div>

            <div *ngIf="group.error" class="sai-note sai-note--danger workbook-sheet-picker__problem">
                <mat-icon class="sai-note__icon icon-size-5" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                <span class="sai-note__text">{{ t("This file could not be read: {{reason}}", { reason: t(group.error) }) }}</span>
            </div>

            <ul class="workbook-sheet-picker__list">
                <li
                    *ngFor="let sheet of group.sheets; trackBy: trackBySheet"
                    class="workbook-sheet-picker__item"
                    [class.workbook-sheet-picker__item--selected]="isSelected(sheet)"
                    [class.workbook-sheet-picker__item--disabled]="!!sheet.error"
                >
                    <div class="workbook-sheet-picker__item-head">
                        <mat-checkbox
                            class="workbook-sheet-picker__checkbox"
                            [checked]="isSelected(sheet)"
                            [disabled]="!!sheet.error"
                            (change)="toggle(sheet, $event.checked)"
                        >
                            <span class="workbook-sheet-picker__name">{{ sheet.name }}</span>
                        </mat-checkbox>
                        <span class="sai-badge sai-badge--rect workbook-sheet-picker__size">
                            {{ t(sheet.rowCount === 1 ? "1 row" : "{{count}} rows", { count: sheet.rowCount }) }},
                            {{ t(sheet.columnCount === 1 ? "1 column" : "{{count}} columns", { count: sheet.columnCount }) }}
                        </span>
                    </div>

                    <div *ngIf="sheet.error" class="sai-note sai-note--warning workbook-sheet-picker__problem">
                        <mat-icon class="sai-note__icon icon-size-5" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
                        <span class="sai-note__text">{{ t(problemKey(sheet)) }}</span>
                    </div>

                    <div
                        *ngIf="sheet.previewHeaders.length"
                        class="sai-table-shell workbook-sheet-picker__preview"
                        tabindex="0"
                        [attr.aria-label]="t('Preview of {{name}}', { name: sheet.name })"
                    >
                        <table>
                            <thead>
                                <tr>
                                    <th *ngFor="let h of sheet.previewHeaders; trackBy: trackByIndex">{{ h }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of sheet.previewRows; trackBy: trackByIndex">
                                    <td *ngFor="let cell of row; trackBy: trackByIndex">{{ cell }}</td>
                                </tr>
                                <tr *ngIf="!sheet.previewRows.length">
                                    <td [attr.colspan]="sheet.previewHeaders.length">{{ t("No data available") }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </li>
            </ul>
        </div>

        <div class="dialog-footer workbook-sheet-picker__footer">
            <button type="button" mat-stroked-button (click)="cancelled.emit()">
                {{ t("Cancel") }}
            </button>
            <button
                type="button"
                mat-flat-button
                [disabled]="!selected.size"
                [class.bg-primary]="selected.size"
                (click)="confirm()"
            >
                <mat-icon svgIcon="heroicons_outline:arrow-right"></mat-icon>
                {{ t("Continue with {{count}} tables", { count: selected.size }) }}
            </button>
        </div>
    </section>
</ng-container>
